// Copyright (c) 2025 Goffy. This file belongs to Goffy. All Rights Reserved.

import React from 'react';
import { StyleSheet } from 'react-native';

import { View, Text } from '@/components/Themed';
import { t } from '@/i18n';

type AppErrorBoundaryState = {
  hasError: boolean;
};

export class AppErrorBoundary extends React.Component<React.PropsWithChildren, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('AppErrorBoundary caught error', error);
    console.error('AppErrorBoundary error stack', error.stack);
    console.error('AppErrorBoundary component stack', info.componentStack);
    if (typeof window !== 'undefined' && window.location?.href) {
      console.error('AppErrorBoundary location', window.location.href);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <View style={styles.container}>
          <Text style={styles.title}>{t('appError.title')}</Text>
          <Text style={styles.message}>{t('appError.message')}</Text>
        </View>
      );
    }

    return this.props.children;
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#0c1429',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    gap: 12,
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: '#e5edff',
    textAlign: 'center',
  },
  message: {
    fontSize: 13,
    color: '#9fb3ff',
    textAlign: 'center',
  },
});
